import OrderDetails from './OrderDetails';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from './OrderDetails.state';

export default connect(mapStateToProps, mapDispatchToProps)(OrderDetails);
